<template>
    <div v-if="playlist">
        <div v-if="!playlist.auto" class="header">
            <h3>Team <strong>Requests</strong></h3>
        </div>
        <draggable
                class="suggested-list-draggable"
                :list="products"
                :move="preventMoveToSuggestedList"
                @start="$emit('drag', true)"
                @end="$emit('drag', false)"
                group="playlist"
                handle=".handle"
                ghostClass="ghost">

            <playlist-item
                    v-for="(product, index) in products"
                    :playlist="playlist"
                    :product="product"
                    :key="product.id"
                    :bg-color="product.bgColor"
                    :added-in-playlist="false"
                    :is-playlist-empty="isPlaylistEmpty"
                    :show-price="isManager"
                    :can-control="isManager"
                    :order="isPlaylistEmpty ? index : index + 1"
                    :tax-rate="taxRate"
                    v-on:fast-track="toggleFastTrack(product.id)">
            </playlist-item>

        </draggable>
    </div>
</template>

<script>
    import PlaylistItem from './playlist-item'
    import PlaylistMixin from '../../mixins/playlist-mixin'
    import draggable from 'vuedraggable'

    export default {
        components: {
            PlaylistItem,
            draggable
        },

        props: {
            playlist: Object,
            isPlaylistEmpty: Boolean,
            isManager: Boolean
        },
        data: function() {
            return  {
                products: [],
                taxRate: Number
            }
        },
        methods: {
            fetchProducts() {
                this.$api.get('suggested_products', {params: { playlistId: this.playlist.id }})
                    .then(res => this.handleProducts(res.data))
                    .catch(console.error)
            },
            preventMoveToSuggestedList(evt) {
                return evt.to.className !== "suggested-list-draggable";
            },
            handleProducts(data) {
                this.products = data.products;
                this.taxRate = data.tax_rate;
                this.products.forEach((p, index) => p.bgColor = this.getPlaylistItemBackgroundColor(p.id))
            },
            toggleFastTrack(productId) {
                this.playlist.force_process_next_batch = true;

                this.$api.post('auto_fast_track', { isFastTracked: true, playlistId: this.playlist.id, productId })
                    .then(() => {
                        this.fetchProducts()
                        this.$emit('refresh-products');
                    })
                    .catch((err) => console.error(err)) // TODO: Toggle back if error
            }
        },
        watch: {
            playlist: function() {
                this.products = undefined;
                this.fetchProducts();
            }
        },
        mixins: [PlaylistMixin]
    }

</script>

<style scoped>
    .header {
        width: 100%;
        padding: 1rem;
        color: #F4F7F1;
        background-color: #1F323B;
    }

    .header h3 {
        margin: 0;
        text-align: start;
    }

    .ghost {
        opacity: 0.4;
    }
</style>
